import React from "react";
import {
  Box,
  HStack,
  VStack,
  Grid,
  GridItem,
  Skeleton,
  useColorModeValue,
} from "@chakra-ui/react";

export default function PnlCalendarSkeleton() {
  const headerBg = useColorModeValue("gray.200", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const shimmerStart = useColorModeValue("gray.100", "gray.700");
  const shimmerEnd = useColorModeValue("blue.50", "gray.600");
  const skeletonProps = { startColor: shimmerStart, endColor: shimmerEnd, speed: 1.2 };

  return (
    <>
      {/* Filter button row */}
      <HStack spacing={3}>
        <Skeleton height="32px" width="90px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Month/Year selector row */}
      <HStack spacing={3}>
        <Skeleton height="36px" width="150px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="36px" width="100px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Monthly stats row */}
      <Grid templateColumns="repeat(6, 1fr)" gap={4}>
        {Array.from({ length: 6 }).map((_, i) => (
          <GridItem key={i} border="1px" borderColor={borderColor} rounded="md" p={3} minWidth="150px">
            <Skeleton height="10px" width="70px" mb={2} {...skeletonProps} />
            <Skeleton height="16px" width="50px" {...skeletonProps} />
          </GridItem>
        ))}
      </Grid>

      {/* Calendar + Weekly totals */}
      <HStack spacing={4} align="start">
        {/* Calendar grid */}
        <VStack spacing={3} align="stretch" flex="1">
          {/* Day-of-week headers */}
          <Grid templateColumns="repeat(7, 1fr)" gap={2}>
            {Array.from({ length: 7 }).map((_, i) => (
              <GridItem key={i} bg={headerBg} border="1px" borderColor={borderColor} rounded="md" p={2} minWidth="120px">
                <Skeleton height="14px" width="40px" mx="auto" {...skeletonProps} />
              </GridItem>
            ))}
          </Grid>
          {/* Calendar cells (6 rows x 7 cols) */}
          <Grid templateColumns="repeat(7, 1fr)" templateRows="repeat(6, 1fr)" gap={2}>
            {Array.from({ length: 42 }).map((_, i) => (
              <GridItem key={i} border="1px" borderColor={borderColor} rounded="md" p={2} minWidth="120px" minH="80px">
                <Skeleton height="12px" width="20px" mb={2} {...skeletonProps} />
                <Skeleton height="10px" width="60px" mx="auto" mb={1} {...skeletonProps} />
                <Skeleton height="12px" width="50px" mx="auto" {...skeletonProps} />
              </GridItem>
            ))}
          </Grid>
        </VStack>

        {/* Weekly totals column */}
        <VStack spacing={3} align="stretch">
          <Box bg={headerBg} border="1px" borderColor={borderColor} rounded="md" p={2} minWidth="120px">
            <Skeleton height="14px" width="90px" mx="auto" {...skeletonProps} />
          </Box>
          {Array.from({ length: 6 }).map((_, i) => (
            <Box key={i} border="1px" borderColor={borderColor} rounded="md" p={2} minWidth="120px" minH="80px">
              <Skeleton height="10px" width="60px" mx="auto" mb={1} {...skeletonProps} />
              <Skeleton height="12px" width="50px" mx="auto" {...skeletonProps} />
            </Box>
          ))}
        </VStack>
      </HStack>
    </>
  );
}
